import { z, ZodType } from 'zod'

import { bulkManagementScope } from 'features/inventory/domain/types/bulkManagementScope'
import { pubAdsServiceRefresh } from 'features/inventory/domain/types/pubAdsServiceRefresh'
import { Domain } from 'features/inventory/types/domain'
import { Ability } from 'providers/casl'
import { commonSchema } from './commonSchema'

export const codeAfter: ZodType<string> = z.string()
export const codeBefore: ZodType<string> = z.string()
export const customCodeEnabled: ZodType<boolean> = z.boolean()

export const editSchema = z
  .object({
    bulkManagementScope: z.enum(bulkManagementScope).default('simplified'),
    customCodeAttributes: z
      .object({
        codeAfter: codeAfter.optional(),
        codeBefore: codeBefore.optional(),
        comment: z.string().optional(),
      })
      .optional(),
    customCodeEnabled,
    id: z.string(),
    overriddenByYieldbird: z.boolean().optional(),
    pubAdsServiceRefresh: z.enum(pubAdsServiceRefresh),
  })
  .extend(commonSchema.shape)

export type EditSchema = z.infer<typeof editSchema>

export const editSchemaDefault = (
  {
    customCode: { codeAfter, codeBefore, comment },
    customCodeEnabled,
    id,
    name,
    overriddenByYieldbird,
    pubAdsServiceRefresh,
  }: Domain,
  ability: Ability,
): EditSchema => ({
  bulkManagementScope: 'simplified',
  customCodeAttributes: {
    codeAfter,
    codeBefore,
    comment,
  },
  customCodeEnabled,
  id,
  name,
  overriddenByYieldbird: ability.can('read', 'DomainField-overriddenByYieldbird')
    ? overriddenByYieldbird
    : undefined,
  pubAdsServiceRefresh: pubAdsServiceRefresh ?? 'controlledByYieldbird',
})
